// extracted by mini-css-extract-plugin
module.exports = {"SkeletonBlock":"📚4-7-03JLfg","loading":"📚4-7-02mbTB","pulsing":"📚4-7-03wPOh"};